import React from 'react';
import './ComingSoon.css';

const ComingSoon = () => {
  return (
    <div className="coming-soon-page">
      <div className="coming-soon-bg" aria-hidden="true">
        <div className="coming-soon-orb coming-soon-orb--1" />
        <div className="coming-soon-orb coming-soon-orb--2" />
        <div className="coming-soon-grid" />
      </div>

      <div className="coming-soon-container">
        <div className="coming-soon-content">
          <div className="coming-soon-logo">
            <img src="/footer_logo.svg" alt="Nova Verse" />
          </div>

          <div className="coming-soon-badge">Launching soon</div>
          <h1 className="coming-soon-title">Coming Soon</h1>
          <p className="coming-soon-subtitle">
            Nova Verse is being prepared for lift-off. We’re polishing the final details see you soon.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;

